export default __webpack_public_path__ + "static/media/fileExcelOn.13d59a78.svg";